import { HttpClient } from '@angular/common/http';
import { ApiService } from '@core/services';
import MultiTranslateHttpLoader from './multi-translate-loader';

export default function MultiTranslateHttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: ApiService.urls.supportAPIUrl + 'chat-api/translates/frontend/',
      suffix: '',
    },
    {
      prefix: ApiService.urls.supportAPIUrl + 'chat-api/translates/games/',
      suffix: '',
    },
  ]);
}
